export function makeArray<T>(prop: T | T[]): T[] {
  if (!prop) {
    return [];
  }

  if (prop instanceof Array) {
    return prop;
  }

  const array = new Array<T>();
  array.push(prop);
  return array;
}
